import './App.css';
import './core/utils/i18n';
import WithGlobalComponents from './core/components/common/withGlobalComponents/withGlobalComponents';

import AppRouter from './core/routes/routes';
import AuthRouter from './core/routes/routes/utils/auth';


function App() {
  return (
    <div className="App">
      <WithGlobalComponents>
        <AuthRouter>
          <AppRouter></AppRouter>
        </AuthRouter>
      </WithGlobalComponents>
    </div>
  );
}

export default App;
